<template>
  <v-container fluid fill-height :class="alt ? 'login-appa' : 'login-app'">
    <v-layout row wrap justify-center fill-height align-center>
      <div class="login-form-shadow login-form-shadow--first" />
      <div class="login-form-shadow login-form-shadow--second" />

      <v-flex style="max-width: 380px;">
        <v-card outlined class="login-card">
          <div style="height: 6px;">
            <v-progress-linear
              color="primary"
              dark
              height="6"
              :active="loading"
              indeterminate
            />
          </div>

          <v-card-text class="px-8" :class="alt ? 'pb-8' : 'pb-12'">
            <div class="mb-5">
              <product-title dark :title="appName" />
            </div>

            <validation-observer ref="form">
              <v-form @submit.prevent="login">
                <v-row dense>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required|email"
                      mode="eager"
                      name="Email"
                    >
                      <v-text-field
                        id="text-field-email"
                        v-model="email"
                        outlined
                        dense
                        label="Email"
                        color="primary"
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required"
                      mode="eager"
                      name="Пароль"
                    >
                      <v-text-field
                        id="text-field-password"
                        v-model="password"
                        outlined
                        dense
                        color="primary"
                        class="pb-0 mb-0"
                        label="Пароль"
                        :append-icon="
                          visiblePassword
                            ? 'mdi-eye-off-outline'
                            : 'mdi-eye-outline'
                        "
                        :type="visiblePassword ? 'text' : 'password'"
                        :error-messages="errors"
                        @click:append="visiblePassword = !visiblePassword"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col class="text-right">
                    <v-btn
                      color="primary"
                      :block="!alt"
                      depressed
                      type="submit"
                    >
                      {{ alt ? "Вход" : "Войти" }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </validation-observer>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import NotificationMixin from "@/mixins/NotificationMixin";
import ProductTitle from "@/components/ProductTitle/ProductTitle";
import "./auth.scss";

export default {
  components: {
    ProductTitle
  },

  mixins: [NotificationMixin],

  data: () => ({
    email: "",
    password: "",
    loading: false,
    visiblePassword: false
  }),

  computed: {
    appName() {
      return this.$store.getters.getSiteName;
    },
    alt() {
      return process.env.VUE_APP_ALT || false;
    }
  },

  methods: {
    async login() {
      try {
        if (!(await this.$refs.form.validate())) return;
        const { email, password } = this;
        this.loading = true;
        await this.$store.dispatch("login", { email, password });
        const userDefaultWorkBenchRoute = this.$store.getters
          .getUserWorkplaceRoute;
        this.$router.push(userDefaultWorkBenchRoute).catch(() => {});
      } catch (error) {
        this.sendError(error);
      } finally {
        this.loading = false;
      }
      return true;
    }
  }
};
</script>
